
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DataPointActionsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a slot action provider for the purpose of contributing a slot action
 */
define([], () => {
	class DataPointActionsProviderAPI {

		/**
		 * @function DataPointActionsProviderAPI#getDataPointActionList
		 * @description Returns a list of data point actions available for specific selections.
		 * @param {selections} selections
		 * @param {options} action's options
		 * @return {array} array containing all available actions
		 */
		getDataPointActionList() { }

	}

	return DataPointActionsProviderAPI;
});